export default () => {
  if (window) {
    window.$('body').addClass('press-hide-menu');
  }
};
